<section>
  <app-toast></app-toast>
    <div *ngIf="!semisterflag">
    <mat-dialog-content class="mat-typography">
      <div class="d-flex align-items-center">
        <div>
          <button mat-icon-button class="back_icon me-2" (click)="closeDialog(false)"><i class="fa-solid fa-arrow-left"></i></button>
        </div>
        <div>
          <h4 translate class="m-0">Add Academic Regulation</h4>
        </div>
      </div>
      <mat-divider class="mt-2"></mat-divider>
      <div class="mt-3">
        <div translate *ngIf="academicsform.errors?.['dateRangeInvalid']" class="error-message">
          End Year must be greater than the Start Year and not more than one year later.
        </div>
        <form [formGroup]="academicsform">
          <div class="row m-0">
            <div *ngFor="let question of questions" class="mb-3 col-12 col-sm-12 col-md-6 col-lg-6 col-xl-4 col-xxl-4">
              <app-question [question]="question" [form]="academicsform"></app-question>
            </div>
          </div>
          <!-- <div class="form-row">
          <button mat-raised-button color="primary" class="px-5 my-4" type="submit" [disabled]="!form.valid">
            Submit
          </button>
        </div> -->
        </form>
      </div>
    </mat-dialog-content>
    <mat-dialog-actions align="end" class="position-absolute bottom-0 end-0">
      <div class="form-row">
        <button translate mat-stroked-button (click)="closeDialog(false)" class="px-5 cancel_button">
          Cancel
        </button>
        <!-- <button mat-raised-button (click)="editcourse()" class="px-5">
          edit
        </button> -->
        <!-- button mat-raised-button (click)="gotosemisters()" class="px-5">
          GoTO
        </button> -->
        <button translate mat-raised-button color="primary" class="submit_button" (click)="onSubmit()" class="px-5" type="submit"
          [disabled]="!academicsform.valid">
          Save
        </button>
      </div>
    </mat-dialog-actions>
    </div>
    <!-- <div *ngIf="semisterflag">
        
      [courseData]="coursedata"
      <app-sections (backtocourseform)="gotosemisters()"></app-sections>
    </div> -->
    
  </section>